import React from "react";
import { FormControl, MenuItem, Select, useMediaQuery } from "@mui/material";
import { FiCheck, FiChevronDown } from "react-icons/fi";
import { ClearableFilter } from "../../common/ClearControls";
import styles from "./Dashboard.module.scss";

type FilterOption = { value: string; label: string };

export default function DashboardFilterSelect({ id, label, value, options, onChange, onClear, fallbackLabel, tone = "orange" }: {
  id: string;
  label: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
  onClear: () => void;
  fallbackLabel?: string;
  tone?: "orange" | "purple";
}) {
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const selection = options.find((option) => option.value === value);

  return <div className={styles.select}>
    <ClearableFilter label={label.toLowerCase()} active={value !== "all"} onClear={onClear}>
      <FormControl fullWidth size="small">
        <Select
          id={id}
          labelId={`${id}-label`}
          value={value}
          onChange={(event) => onChange(String(event.target.value))}
          IconComponent={FiChevronDown}
          renderValue={() => selection?.label || fallbackLabel || value}
          MenuProps={{
            disableScrollLock: true,
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            transitionDuration: reducedMotion ? 0 : { enter: 190, exit: 130 },
            PaperProps: { className: `${styles.filterMenuPaper} ${tone === "purple" ? styles.aiFilterMenu : ""}` },
            MenuListProps: { className: styles.filterMenuList },
          }}
        >
          {!selection && <MenuItem value={value} disabled>{fallbackLabel || value}</MenuItem>}
          {options.map((option) => <MenuItem className={styles.filterMenuItem} key={option.value} value={option.value}>
            <span>{option.label}</span>
            <FiCheck className={styles.filterMenuCheck} aria-hidden="true" />
          </MenuItem>)}
        </Select>
      </FormControl>
    </ClearableFilter>
  </div>;
}
